<template>
  <section class="txvideo12">
    <div class="txvideo12-header">
      <van-image
        class="txvideo12-header-bg"
        :src="$getConfigValue('VISITOR_HEADER_IMAGE', source)"
        lazy-load
      />
    </div>
    <section class="login-form">
      <div class="login-form-tip">
        登录即代表同意<agreement-popup
          title="《会员服务协议》"
          :agreementName="namespace"
        >
          《会员服务协议》
        </agreement-popup>
      </div>
      <van-button
        v-ans="{ event_id: 'visitor_click_buy' }"
        class="login-form-btn"
        block
        type="primary"
        @click="loginUse"
        >立即登录</van-button
      >
    </section>
    <section class="txvideo12-content">
      <van-image
        src="https://common-h5-dev.xiangshuheika.com/static/upload/2025051497c05f1d25a8c.png"
        lazy-load
      />
    </section>
    <section class="rule">
      <div class="rule-title">【活动规则】</div>
      <div
        class="rule-content"
        v-html="$getConfigValue('COMMON_VISITOR_RULE', source)"
      ></div>
    </section>
  </section>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import { isValidPhone } from "@/helper/validate";
import { checkPhone, loginByPhone } from "@/apis";
import { toPayV2 } from "@/helper/pay";
import { getPackageList, getPaymethod } from "@/apis/product";
import LoginDialog from "@/components/loginDialog";

export default {
  data() {
    return {
      phone: "",
      loading: false,
      memberPackage: {},
      payMethod: {},
      disabled: false,
    };
  },
  computed: {
    ...mapState(["namespaceInfo", "namespace", "source", "token", "isMember"]),
  },
  async mounted() {
    this.phone = sessionStorage.getItem("txvideo12_phone") || "";
    this.disabled = !!this.phone;
    const [res, payMethodRes] = await Promise.all([
      getPackageList({
        namespace: this.namespace,
        source: this.source,
      }),
      getPaymethod({
        namespace: this.namespace,
        product_type: this.namespace.toUpperCase(),
        source: "default",
      }),
    ]);
    if (res.data.length) {
      this.memberPackage = res.data[0];
    }
    if (payMethodRes.length) {
      this.payMethod = payMethodRes[0];
    }
  },
  methods: {
    ...mapActions(["fetchUserInfo"]),
    ...mapMutations(["changeState"]),
    async login() {
      this.loading = true;
      if (!this.phone) {
        this.$toast("请输入手机号");
        return;
      }
      if (!isValidPhone(this.phone)) {
        this.$toast("请输入正确的手机号");
        return;
      }

      //检测手机号是否为空号
      const checkRes = await checkPhone({
        phone: this.phone,
      });
      const { checked, status } = checkRes.data;
      if (checked && ["空号", "沉默号"].includes(status)) {
        await this.$confirm({
          title: "温馨提示",
          message: `系统检测到手机号：<b>${this.phone}</b>可能为空号，是否继续？`,
          cancelButtonText: "我再想想",
          confirmButtonText: "确认号码",
        });
      }
      const res = await loginByPhone({
        code: this.phone,
        phone_number: this.phone,
        namespace: this.ns || this.namespace,
        source: this.source || "",
      });
      const { user_token } = res.data;
      this.changeState({ token: user_token, ptoken: user_token });
      const userInfo = await this.fetchUserInfo();
      sessionStorage.setItem("txvideo12_phone", this.phone);
      this.loading = false;
      if (userInfo.is_member) {
        this.$toast("您已经是会员了");
        setTimeout(() => {
          this.$router.replace("/index");
        }, 1000);
        return;
      }
      // 开通会员
      toPayV2(this.memberPackage, this.payMethod.channel);
    },
    loginUse() {
      if (this.token) {
        if (this.isMember) {
          this.$router.replace("/index");
        } else {
          this.$toast("您还未开通会员");
        }
        return;
      }
      LoginDialog.show({
        className: "tvvideo12-login-dialog",
        needCheck: false,
        title: "请输入权益领取手机号",
      }).then((res) => {
        this.phone = res.input_phone;
        this.disabled = res.input_phone;
        sessionStorage.setItem("txvideo12_phone", res.input_phone);
        if (res.is_member) {
          this.$router.replace("/index");
        } else {
          this.$toast("您还未开通会员");
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.txvideo12 {
  padding-bottom: 20px;
}
.txvideo12-header {
  height: 289px;
  position: relative;
}
.txvideo12-header-entry {
  position: absolute;
  top: 10px;
  right: 0;
  width: 82px;
  height: 44px;
}
.txvideo12-header-bg {
  height: 100%;
  display: block;
}

.login-form {
  margin: -20px 16px 16px;
  position: relative;
  z-index: 10;
  padding: 24px 12px;
  background: linear-gradient(180deg, #ffd5d5 0%, #fff2f2 100%);
  border-radius: 8px;
}

.login-form-input {
  width: 90%;
  margin: 0 auto;
  font-size: 14px;
  border-radius: 8px;
}
.login-form-tip {
  margin: 14px 0;
  text-align: center;
  line-height: 14px;
  color: #999;
  span {
    color: #1677ff;
  }
}

.login-form-btn {
  height: 50px;
  background: linear-gradient(#fc617a 0%, #fc1c39 100%);
  box-shadow: 0px 0px 0px 2px rgba(255, 166, 93, 0.6);
  border-radius: 25px;
  color: #fff;
  border: none;
  font-size: 20px;
}

.txvideo12-content {
  margin-bottom: 24px;
}

.rule-title {
  line-height: 28px;
  text-align: center;
  font-size: 16px;
  margin-bottom: 10px;
  color: #702b19;
}
.rule-content {
  padding: 0 16px;
  color: #702b19;
  font-size: 14px;
  line-height: 20px;
}
</style>
<style lang="less">
.tvvideo12-login-dialog {
  background: linear-gradient(180deg, #ffd5d5 0%, #ffffff 100%);
  width: 80%;
  padding: 0 16px 32px;
  .login-agreement {
    display: none;
  }
  .field-input {
    border-radius: 8px;
  }
  .get-code {
    margin-top: 8px;
  }
  .form-submit {
    margin: 0;
  }
  .van-button {
    background: linear-gradient(#fc1c39, #fc617a);
    color: #fff;
  }
  .code {
    border: none;
  }
  .dialog-close {
    background-image: url("../../../assets/images/close-white.svg");
    background-size: 16px;
  }
}
</style>
